import { render } from "./EscalaPregacoes.vue?vue&type=template&id=e0e57dc2"
import script from "./EscalaPregacoes.vue?vue&type=script&lang=js"
export * from "./EscalaPregacoes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__